import React, { useEffect } from "react";
import { Navigate, Route } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";
import { logoutUser } from "../slices/thunks";
import AuthService from "../admin/components/login/AuthService";

const AuthProtected = ({ children, allowedRoles }) => {
  const dispatch = useDispatch();
  const userData = AuthService.getUserData();
  const token = AuthService.getToken();

  useEffect(() => {
    if (userData) {
      setAuthorization(token);
    } else if (!userData && !token) {
      dispatch(logoutUser());
    }
  }, [token, userData, dispatch]);

  if (!userData && !token) {
    return <Navigate to={{ pathname: "/login" }} />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    const role = userData?.role || "user";
    if (!allowedRoles.includes(role)) {
      return <Navigate to="/admin/unauthorized" />;
    }
  }

  return <>{children}</>;
};

const AccessRoute = ({ component: Component, allowedRoles, ...rest }) => {
  return (
      <Route
          {...rest}
          element={
            <AuthProtected allowedRoles={allowedRoles}>
              <Component />
            </AuthProtected>
          }
      />
  );
};

export { AuthProtected, AccessRoute };
